import * as React from 'react';
import { Graft } from "./TriggerClasses";
import { PreviewProcedureModel } from '../PreviewProcedureModel';
import { StudyModel } from '../StudyModel';
import { DataHelper } from '../../Helpers/DataHelper';
import GraftBuilder from './GraftBuilder';
import CardiacSubwayMap from './CardiacSubwayMap';


class CardiacWorklist extends React.Component < {
    CurrentItems : Graft[],
    TimeSteps: string[],
    parentProcedure: PreviewProcedureModel,
    studySelected: StudyModel, 
        dataHelper: DataHelper,
        measurementAllocated?: (procedureType: string,timestep:string, procedureId: string, measurementId: string, graftId: string) => void,
        addNewGraft: (newGraft: Graft) => void,
        updateExistingGraft: (updatedGraft: Graft) => void,
        procedureTypes: string[],
        changeProcedureType: (newType: string) => void
}, {
    builderShown: boolean,
    GraftSelected: Graft,
    indexSelected: number,
    showTimeStepsSelector: boolean,
    protocolStepsToAdd: string[]
},
any > {

    static defaultProps = {
       
      }

    constructor(props : any) {
        super(props);
        this.state = {
          builderShown: false,
          indexSelected: -1,
          GraftSelected: null as any,
          showTimeStepsSelector: false,
          protocolStepsToAdd: []
        };
    }

    
    render() {
        
         let procedureStepElements: React.ReactElement[] = [];
         for (let index = 0; index < this.props.procedureTypes.length; index++) {
             let protocolSteps: string[] = [];
            let currentProcedureType = this.props.procedureTypes[index];
 //Loop through measurements in procedure and get unique performedProcedureSteps for those assigned to this graft.
        for (let index = 0; index < this.props.parentProcedure?.measurements.length; index++) {
            const element = this.props.parentProcedure?.measurements[index];
        
            if (element.performedProcedureStep as string && (element.performedProcedure === currentProcedureType || !element.performedProcedure))
            {
                if (protocolSteps.indexOf(element.performedProcedureStep as string) === -1)
                {
                    protocolSteps.push(element.performedProcedureStep as string);
                }
            }
        }
        for (let index = 0; index < this.state.protocolStepsToAdd.length; index++) {
            const element = this.state.protocolStepsToAdd[index];
            if (protocolSteps.indexOf(element) === -1)
            {
                protocolSteps.push(element);
            }   
        }
        if (protocolSteps.length === 0)
            protocolSteps = [Object.keys(Graft.CardiacTimeStepsLookup)[1]];

        protocolSteps.sort((a, b) => {
            const lookup = Graft.CardiacTimeStepsLookup;
            const aIdx = lookup[a]?.index ?? Number.MAX_SAFE_INTEGER;
            const bIdx = lookup[b]?.index ?? Number.MAX_SAFE_INTEGER;
            return aIdx - bIdx;
        });

        let timeStepsSelectorElement = 
        
        
        <div className='timesteppopup'>

            <button className='overlayClose' onClick={()=>{
            this.setState({
                showTimeStepsSelector: !this.state.showTimeStepsSelector
            });
        }}>
            X

            </button> 

            <div className='timeStepPopupWrapper'>
                <div className='toggleButtonsWraper'>
            {Object.keys(Graft.CardiacProcedureTypesLookup).map( (procedureType: string, index: number) => {
                return <div onClick={()=>{
                this.props.changeProcedureType(procedureType)
            }} className={'timestepProcedure primaryButton ' + (currentProcedureType  === procedureType ? "Pressed" : "")}>{Graft.CardiacProcedureTypesLookup[procedureType].name}</div>;
            })}    
            </div>

            <div className='timeStepsMenu'>
                <ul>
                   {
                Object.keys(Graft.CardiacTimeStepsLookup).map((timestep: string, index: number) => {
                    if (currentProcedureType === Object.keys(Graft.CardiacProcedureTypesLookup)[0] || !Graft.CardiacTimeStepsLookup[timestep].onpumponly)
                        return (
                            <li key={timestep}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={protocolSteps.includes(timestep)}
                                        onChange={(e) => {
                                            let protocolStepsIn = this.state.protocolStepsToAdd;
                                            // Add or remove timestep from protocolSteps
                                            if (e.target.checked) {
                                                if (!protocolStepsIn.includes(timestep)) {
                                                    protocolStepsIn.push(timestep);
                                                    this.setState({
                                                        protocolStepsToAdd: protocolStepsIn
                                                    });
                                                }
                                            } else {
                                                const idx = protocolStepsIn.indexOf(timestep);
                                                if (idx !== -1) {
                                                    protocolStepsIn.splice(idx, 1);
                                                    this.setState({
                                                        protocolStepsToAdd: protocolStepsIn
                                                    });
                                                }
                                            }
                                        }}
                                    />
                                    {Graft.CardiacTimeStepsLookup[timestep].name}
                                </label>
                            </li>
                        );
                        return <></>;
                })
            }
                </ul>
            </div>

            </div>

            
            
        </div>;
     
        

        let timeSteps = protocolSteps.map( (timestep: string, index: number) => {
            return <span className='timeStepTitle'>{Graft.CardiacTimeStepsLookup[timestep] ? Graft.CardiacTimeStepsLookup[timestep].name : timestep}</span>;
        });
        let timestepsHeadings = <div className='timesteps-headings visual-row-container'>
            <div className='plain-container'>
                <table className="subway">
                    <tr className="child0">
                        <td className='td1'></td>
                        <td className='td2'></td>
                        <td className='td3'>{timeSteps}
                            <div className='addTimestep'>

                                <button className='intuiButton iconButton' onClick={()=>{
            this.setState({
                showTimeStepsSelector: !this.state.showTimeStepsSelector
            });
        }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 8C1.71875 8 1.45312 7.94792 1.20312 7.84375C0.963542 7.73958 0.755208 7.59896 0.578125 7.42188C0.401042 7.24479 0.260417 7.03646 0.15625 6.79688C0.0520833 6.54688 0 6.28125 0 6V2C0 1.71875 0.0520833 1.45833 0.15625 1.21875C0.260417 0.979167 0.401042 0.770833 0.578125 0.59375C0.765625 0.40625 0.979167 0.260417 1.21875 0.15625C1.45833 0.0520833 1.71875 0 2 0H6C6.27083 0 6.52604 0.0520833 6.76562 0.15625C7.01562 0.260417 7.22917 0.40625 7.40625 0.59375C7.59375 0.770833 7.73958 0.984375 7.84375 1.23438C7.94792 1.47396 8 1.72917 8 2V6C8 6.28125 7.94792 6.54167 7.84375 6.78125C7.73958 7.02083 7.59375 7.23438 7.40625 7.42188C7.22917 7.59896 7.02083 7.73958 6.78125 7.84375C6.54167 7.94792 6.28125 8 6 8H2ZM2 2V6H6V2H2ZM11 4C10.7292 4 10.4948 3.90104 10.2969 3.70312C10.099 3.50521 10 3.27083 10 3C10 2.72917 10.099 2.49479 10.2969 2.29688C10.4948 2.09896 10.7292 2 11 2H27C27.2708 2 27.5052 2.09896 27.7031 2.29688C27.901 2.49479 28 2.72917 28 3C28 3.27083 27.901 3.50521 27.7031 3.70312C27.5052 3.90104 27.2708 4 27 4H11ZM2 18C1.71875 18 1.45312 17.9479 1.20312 17.8438C0.963542 17.7396 0.755208 17.599 0.578125 17.4219C0.401042 17.2448 0.260417 17.0365 0.15625 16.7969C0.0520833 16.5469 0 16.2812 0 16V12C0 11.7188 0.0520833 11.4583 0.15625 11.2188C0.260417 10.9792 0.401042 10.7708 0.578125 10.5938C0.765625 10.4062 0.979167 10.2604 1.21875 10.1562C1.45833 10.0521 1.71875 10 2 10H6C6.27083 10 6.52604 10.0521 6.76562 10.1562C7.01562 10.2604 7.22917 10.4062 7.40625 10.5938C7.59375 10.7708 7.73958 10.9844 7.84375 11.2344C7.94792 11.474 8 11.7292 8 12V16C8 16.2812 7.94792 16.5417 7.84375 16.7812C7.73958 17.0208 7.59375 17.2344 7.40625 17.4219C7.22917 17.599 7.02083 17.7396 6.78125 17.8438C6.54167 17.9479 6.28125 18 6 18H2ZM2 12V16H6V12H2ZM11 14C10.7292 14 10.4948 13.901 10.2969 13.7031C10.099 13.5052 10 13.2708 10 13C10 12.7292 10.099 12.4948 10.2969 12.2969C10.4948 12.099 10.7292 12 11 12H27C27.2708 12 27.5052 12.099 27.7031 12.2969C27.901 12.4948 28 12.7292 28 13C28 13.2708 27.901 13.5052 27.7031 13.7031C27.5052 13.901 27.2708 14 27 14H11ZM2 28C1.71875 28 1.45312 27.9479 1.20312 27.8438C0.963542 27.7396 0.755208 27.599 0.578125 27.4219C0.401042 27.2448 0.260417 27.0365 0.15625 26.7969C0.0520833 26.5469 0 26.2812 0 26V22C0 21.7188 0.0520833 21.4583 0.15625 21.2188C0.260417 20.9792 0.401042 20.7708 0.578125 20.5938C0.765625 20.4062 0.979167 20.2604 1.21875 20.1562C1.45833 20.0521 1.71875 20 2 20H6C6.27083 20 6.52604 20.0521 6.76562 20.1562C7.01562 20.2604 7.22917 20.4062 7.40625 20.5938C7.59375 20.7708 7.73958 20.9844 7.84375 21.2344C7.94792 21.474 8 21.7292 8 22V26C8 26.2812 7.94792 26.5417 7.84375 26.7812C7.73958 27.0208 7.59375 27.2344 7.40625 27.4219C7.22917 27.599 7.02083 27.7396 6.78125 27.8438C6.54167 27.9479 6.28125 28 6 28H2ZM2 22V26H6V22H2ZM11 24C10.7292 24 10.4948 23.901 10.2969 23.7031C10.099 23.5052 10 23.2708 10 23C10 22.7292 10.099 22.4948 10.2969 22.2969C10.4948 22.099 10.7292 22 11 22H27C27.2708 22 27.5052 22.099 27.7031 22.2969C27.901 22.4948 28 22.7292 28 23C28 23.2708 27.901 23.5052 27.7031 23.7031C27.5052 23.901 27.2708 24 27 24H11Z" fill="black"/>
            </svg>

            </button> 
             {
                
            this.state.showTimeStepsSelector ?
            timeStepsSelectorElement
            
            : <></>
        }</div></td></tr></table></div></div>;

        let fullElementToAdd = 
        <div className='subwayMapsContainer'>
            <div className='subwayMaps'>
                <div className='procedureTypeHeading'>{Graft.CardiacProcedureTypesLookup[currentProcedureType] ? Graft.CardiacProcedureTypesLookup[currentProcedureType].name : currentProcedureType}</div>
        {timestepsHeadings}
      
    {this.props.CurrentItems.map( (graftItem: Graft, index: number) => {

        return (
            <CardiacSubwayMap key={index} procedureType={currentProcedureType} protocolSteps={protocolSteps} showSelected={false} editGraftClicked={(timestep:string, procedureId: string, graftid:string)=>
            {
                //First find the graft.
                for (let graftIndex = 0; graftIndex < this.props.CurrentItems.length; graftIndex++) {
                                      const GraftIn = this.props.CurrentItems[graftIndex];
                                      let graftFound = Graft.findGraftWithId(GraftIn, GraftIn, graftid);
                                      if (graftFound)
                                      {
                                            this.setState({
                                                            GraftSelected: graftFound,
                                                            indexSelected: graftIndex,
                                                            builderShown: true
                                                        });
                                      }
                                    }
                
            }} showeditbutton={true} measurementAllocated={this.props.measurementAllocated} CurrentItem={graftItem} parentProcedure={this.props.parentProcedure} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper}showsaves={true}></CardiacSubwayMap>
            // <SubwayMap key={index} Context='Cardiac' showSelected={false} editGraftClicked={(timestep:string, procedureId: string, graftid:string)=>
            // {
            //     //First find the graft.
            //     for (let graftIndex = 0; graftIndex < this.props.CurrentItems.length; graftIndex++) {
            //                           const GraftIn = this.props.CurrentItems[graftIndex];
            //                           let graftFound = Graft.findGraftWithId(GraftIn, GraftIn, graftid);
            //                           if (graftFound)
            //                           {
            //                                 this.setState({
            //                                                 GraftSelected: graftFound,
            //                                                 indexSelected: graftIndex,
            //                                                 builderShown: true
            //                                             });
            //                           }
            //                         }
                
            // }
            // } measurementAllocated={this.props.measurementAllocated} CurrentItem={graftItem} parentProcedure={this.props.parentProcedure} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} customGraftText='' commentToggled={()=>{}} index={index} tileColorOn={false} showsaves={true} measurementSelectionOpen={false} measurementSelectionSelected={()=>{}}></SubwayMap>
        );
    })}
        </div>

        <button className='intuiButton addGraft' onClick={()=>{
            this.setState({
                GraftSelected: Graft.getBlankGraft(false, null as any, "CABG"),
                indexSelected: -1,
                builderShown: true
            });
        }}>Add new Graft</button>


    </div>;
    procedureStepElements.push(fullElementToAdd);

         }
       
            return ( <>
            <div>
                {!this.state.builderShown ? 
    (<div>
        {procedureStepElements}
     
        
     </div>)
     :
     (<div className='graftBuilderPopupWrapper'><div className='backBlack'></div><div>Graft Builder!</div><GraftBuilder closeGraftBuilder={()=>{
        this.setState({
            builderShown: false,
            GraftSelected: Graft.getBlankGraft(false, null as any, "CABG"),
            indexSelected: -1
        });
     }} SaveGraft={(graftIn: Graft)=>{
        //Update the CurrentItems of the parent somehow.
        if (this.state.indexSelected === -1)
            this.props.addNewGraft(graftIn);
        else
            this.props.updateExistingGraft(graftIn);
        this.setState({
            builderShown: false,
            GraftSelected: Graft.getBlankGraft(false, null as any, "CABG"),
            indexSelected: -1
        });
     }} CurrentGraft={this.state.GraftSelected} setCustomGraft={()=>{}} customGraftText={''} frequentGraftSelected={()=>{}} simpleMode={true} Context={''} graftsUpdated={()=>{}} editGraftClicked={()=>{}} subGraftSelected={new Graft()}></GraftBuilder></div>)}
     </div>
    </>     
    )
  }
}

export default CardiacWorklist;